export const shufflingImages = async () => {
    const animatedDivs = [...document.querySelectorAll<HTMLElement>('.shuffling-images > div')];
    if (animatedDivs.length >= 2) {
        animatedDivs.slice(1).forEach(div => {
            div.style.opacity = '0';
        });

        const controls = document.querySelector<HTMLButtonElement>('.shuffling-images .play-pause-button');
        let paused = false;
        let resume: (() => void) | undefined;

        controls?.addEventListener('click', () => {
            paused = !paused;
            controls.classList.toggle('play-pause-button--paused', paused);
            controls.setAttribute('aria-label', `${paused ? 'Play' : 'Pause'} ${controls.dataset.mediaLabel}`);
            if (!paused) {
                resume?.();
                resume = undefined;
            }
        });

        let i = 0;
        while (true) {
            const current = animatedDivs[i];
            i = (i + 1) % animatedDivs.length;
            const next = animatedDivs[i];
            next.style.opacity = '1';
            current.style.zIndex = '2';
            await new Promise(resolve => setTimeout(resolve, 1250));
            if (paused) {
                await new Promise<void>(resolve => { resume = resolve; });
            }
            current.style.zIndex = '1';
            current.style.opacity = '0';
        }
    }
}